import { useQuery } from "@tanstack/react-query";
import { getClientCourses } from "@/http/coursesApi";
import { getCookie } from "@/utils/cookies";
import { getClientCoursesQueryKey } from "@/utils/queryKeys";
import type { ClientCourse } from "@/@types/courses.types";

export const useGetClientCoursesQuery = () => {
  const userToken = getCookie("user_token");

  return useQuery<ClientCourse[]>({
    queryKey: [...getClientCoursesQueryKey(), { userToken }],
    queryFn: async () => {
      if (!userToken) return [];
      const response = await getClientCourses(userToken);
      return response.data.data ?? [];
    },
    enabled: !!userToken,
  });
};
